import { useContext } from "react";
import { ViewerItemsSelectionContext } from "./viewer-items-selection-context-props.ts";

const useViewerItemsSelectionContext = () => {
    const context = useContext(ViewerItemsSelectionContext);
    if (!context) {
        throw new Error("useViewerItemsSelectionContext must be used within a ViewerItemsSelectionContextProvider");
    }
    return context;
}

export default useViewerItemsSelectionContext;